<template>
  <div>
    <a-form  layout="inline" class="ant-advanced-search-form">
      <a-form-item label="Field A">
        <a-input size="small"/>
      </a-form-item>
      <a-form-item label="Field B">
        <a-select defaultValue="1" size="small"  style="width: 200px">
          <a-select-option value="1">栖息在</a-select-option>
          <a-select-option  value="2">栖息在</a-select-option>
          <a-select-option  value="3">栖息在</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="Field B">
        <a-input size="small"/>
      </a-form-item>
      <a-form-item label="Field B">
        <a-input size="small"/>
      </a-form-item>
      <a-form-item label="Field B">
        <a-input size="small"/>
      </a-form-item>
      <a-form-item label="Field B">
        <a-input size="small"/>
      </a-form-item>
      <a-form-item label="Field B">
        <a-input size="small"/>
      </a-form-item>
      <a-form-item :wrapper-col="8">
        <a-button type="primary" size="small">Submit</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
export default {
  name: "about",
  data() {
    return {
      formLayout: "inline"
    };
  },
  computed: {
    formItemLayout() {
      const { formLayout } = this;
      return formLayout === "horizontal"
        ? {
            labelCol: { span: 4 },
            wrapperCol: { span: 14 }
          }
        : {};
    },
    buttonItemLayout() {
      const { formLayout } = this;
      return formLayout === "horizontal"
        ? {
            wrapperCol: { span: 14, offset: 4 }
          }
        : {};
    }
  },
  methods: {
    handleFormLayoutChange(e) {
      this.formLayout = e.target.value;
    }
  }
};
</script>


<style scoped>
.custom-filter-dropdown {
  padding: 8px;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
.ant-advanced-search-form .ant-form-item {
    margin-bottom: 0px;
}

.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}
.ant-advanced-search-form {
  padding: 12px;
  background: #fbfbfb;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
}
</style>